import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { I18nProvider } from "./contexts/I18nContext";
import { AuthProvider } from "./contexts/AuthContext";
import PublicLayout from "./components/layout/PublicLayout";
import Home from "./pages/Home";
import About from "./pages/About";
import Districts from "./pages/Districts";
import DistrictDetail from "./pages/DistrictDetail";
import Courses from "./pages/Courses";
import CourseDetail from "./pages/CourseDetail";
import Books from "./pages/Books";
import Volunteers from "./pages/Volunteers";
import Programmes from "./pages/Programmes";
import Gallery from "./pages/Gallery";
import Donate from "./pages/Donate";
import Team from "./pages/Team";
import Contact from "./pages/Contact";
import SearchPage from "./pages/Search";
import AuthCallback from "./pages/AuthCallback";
import AdminLogin from "./pages/AdminLogin";
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/districts" element={<Districts />} />
        <Route path="/districts/:name" element={<DistrictDetail />} />
        <Route path="/spoken" element={<Navigate to="/" replace />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/courses/:id" element={<CourseDetail />} />
        <Route path="/books" element={<Books />} />
        <Route path="/volunteers" element={<Volunteers />} />
        <Route path="/programmes" element={<Programmes />} />
        <Route path="/training" element={<Navigate to="/" replace />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/team" element={<Team />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </PublicLayout>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}
